import { render, staticRenderFns } from "./FormTrade.vue?vue&type=template&id=b9c17452&scoped=true&"
import script from "./FormTrade.vue?vue&type=script&lang=js&"
export * from "./FormTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c17452",
  null
  
)

export default component.exports